import useVisible from "../../hooks/useVisible.jsx";
import ppText from "../../utils/buttons/ppText";
import handleClick from "../../utils/handleClick.js";

function ExportElementsPremiere({selectedTag, buttonTags, generateButtonTags}) {
  const [isVisible, setIsVisible] = useVisible('ExportElementsPremiereVisibility');

  if (selectedTag && !buttonTags.includes(selectedTag)) {
  return null;
}

  return (
    <>
      <li
          onClick={() => setIsVisible(!isVisible)}
          className={`button-card resolution-toggle ${isVisible ? 'active' : ''}`}
      >
          <div className="button-card__icon">
          <i class="fa-regular fa-square-e"></i>
        <div />
      </div>
      <div className="button-card__title">Export Elements Premiere</div>
      {generateButtonTags()}
      </li>
      <div className={`resolution-tools ${isVisible ? '' : 'hidden'}`}>

      <div
        onClick={() => handleClick("ppSortFiles", true)}
        className="resolution-tools__button"
      >
        <i class="fa-solid fa-bars-sort"></i><span>Sort Files</span>
      </div>
      <div
        onClick={() => ppText(false)}
        className="resolution-tools__button"
      >
        <i class="fa-solid fa-text"></i><span>Text Layer</span>
      </div>
      <div
        onClick={() => handleClick("ppTrackMatte", true)}
        className="resolution-tools__button"
      >
        <i class="fa-sharp fa-regular fa-object-group"></i><span>Track Matte</span>
      </div>
      <div
        onClick={() => handleClick("ppColors", true)}
        className="resolution-tools__button"
      >
        <i class="fa-regular fa-palette"></i><span>Colors Effect</span>
      </div>
      <div
        onClick={() => handleClick("ppShiftChannels", true)}
        className="resolution-tools__button"
      >
        <i class="fa-regular fa-sliders"></i><span>Shift Channels</span>
      </div>
      <div
        onClick={() => handleClick("ppLockLayer", true)}
        className="resolution-tools__button"
      >
        <i class="fa-sharp fa-regular fa-lock"></i><span>Lock Layer</span>
      </div>
    </div>
    </>
  );
}

export default ExportElementsPremiere;
